import { type CSSProperties, type NestedCSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../../core/styles.constants';

export const infoCard = (withOnClick: boolean): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  padding: 16,
  background: StyleConstants.WHITE_COLOR,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 8,
});

export const facilityTypeCard = (withOnClick: boolean, isEnabled = true): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  paddingInlineEnd: 16,
  paddingInlineStart: 16,
  background: isEnabled ? StyleConstants.WHITE_COLOR : StyleConstants.LIGHT_GREY_COLOR,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 24,
});

export const cardGroupHeader = (hasMargin?: boolean): CSSProperties => ({
  marginBottom: hasMargin ? 8 : undefined,
  wordBreak: 'break-word',
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  width: '100%',
});

export const cardHeader = (hasMargin?: boolean): CSSProperties => ({
  marginBottom: hasMargin ? 8 : undefined,
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
});

export const cardBody = (isLastItem: boolean, hasMargin?: boolean): CSSProperties => ({
  marginTop: hasMargin ? 8 : undefined,
  marginBottom: isLastItem ? undefined : 8,
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  width: '100%',
});

// PrimaryButton hardcodes its own width to 180px unless `fullWidth` is passed — this wrapper
// reserves that width up front (rather than only once the button conditionally appears) so the
// row's other fields don't visually shift/reflow when a threshold edit becomes "changed".
export const inlineSaveButtonWrap: CSSProperties = {
  width: 140,
  flexShrink: 0,
};

export const inlineValidationMessage: CSSProperties = {
  color: StyleConstants.PINK_COLOR,
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  marginTop: 4,
};

export const emailBody: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  minHeight: 32,
};

export const deleteIcon: NestedCSSProperties = {
  cursor: 'pointer',
  color: StyleConstants.LIGHT_GREY_COLOR,
  height: '100%',
  minHeight: 18,
  minWidth: 18,
  $nest: {
    '&:hover': {
      color: StyleConstants.PINK_COLOR,
    },
  },
};

export const editIcon: NestedCSSProperties = {
  cursor: 'pointer',
  color: StyleConstants.LIGHT_GREY_COLOR,
  height: '100%',
  minHeight: 18,
  minWidth: 18,
  $nest: {
    '&:hover': {
      color: StyleConstants.ORANGE_COLOR,
    },
  },
};

export const checkIcon = (isChecked: boolean): CSSProperties => ({
  color: StyleConstants.ORANGE_COLOR,
  minHeight: 14,
  minWidth: 14,
  maxHeight: 14,
  maxWidth: 14,
  opacity: isChecked ? 1 : 0,
});

export const facilityTypeBodyText: CSSProperties = {
  width: '100%',
  paddingLeft: 8,
  paddingRight: 8,
};

export const emailBodyText: CSSProperties = {
  width: '100%',
};
